import { render, staticRenderFns } from "./ReqToImproveApplicationView.vue?vue&type=template&id=2ff689ad"
import script from "./ReqToImproveApplicationView.vue?vue&type=script&lang=js"
export * from "./ReqToImproveApplicationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports